export enum RpmEventStateType {
  NO_DATA = 'NO_DATA',
  SOME_NOT_VIEWED = 'SOME_NOT_VIEWED',
  ALL_VIEWED = 'ALL_VIEWED',
}
